import { useCallback } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import {
  getTreeMapCalculatedData,
  getPeriodByEntity,
  getLastUpdateTimestamp,
  getActiveWatchlist,
} from 'src/redux/selectors'
import { setGroupByEntity } from 'src/redux/thunks'

export const useConnectedState = ({ props }) => {
  const data = useSelector(state => getTreeMapCalculatedData(state, props))

  // const globalSearchSymbol = useSelector(getGlobalSearch)
  const globalSearchSymbol = ''
  const watchListObject = useSelector(getActiveWatchlist)
  const periods = useSelector(getPeriodByEntity)
  // const tooltipState = useSelector(getTooltipState)
  const tooltipState = true
  const updateTimestamp = useSelector(getLastUpdateTimestamp)

  return {
    data,
    globalSearchSymbol,
    watchListObject,
    periods,
    tooltipState,
    updateTimestamp,
  }
}

export const useActions = () => {
  const dispatch = useDispatch()
  const store = useStore()

  const setGroup = useCallback(
    group => {
      dispatch(setGroupByEntity(group))
    },
    [dispatch]
  )

  const connectedDeleteWatchListItems = useCallback(
    symbol => deleteWatchListItems(symbol)(dispatch, store.getState),
    [dispatch, store]
  )

  const connectedAddWatchListItems = useCallback(
    symbol => addWatchListItems(symbol)(dispatch, store.getState),
    [dispatch, store]
  )

  return {
    addWatchListItems: connectedAddWatchListItems,
    deleteWatchListItems: connectedDeleteWatchListItems,
    setGroup,
  }
}
